var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _g3, _path7, _g4, _path8, _g5, _g6, _path9, _g7, _g8, _g9, _path0, _g0, _path1, _g1, _g10, _path10, _g11, _g12, _g13, _g14, _path11, _g15, _path12, _path13, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path14, _g23, _path15, _g24, _path16, _g25, _g26, _g27, _g28, _g29, _g30, _path17, _path18, _g31, _path19, _g32, _path20, _path21, _g33, _path22, _g34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinuxColorIcon = function SvgLinuxColorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linux-color-icon_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#020204",
    d: "M18.383 9.203c.283.617.6 1.219.88 1.837.541 1.19.952 2.446 1.123 3.741.17 1.296.096 2.634-.308 3.876-.458 1.402-1.327 2.65-2.391 3.671-1.26 1.208-2.876 2.14-4.62 2.208-1.135.045-2.266-.28-3.272-.81a7.5 7.5 0 0 1-2.234-1.768 6.04 6.04 0 0 1-1.284-2.532c-.261-1.147-.143-2.365.251-3.474.283-.792.701-1.53.999-2.317.325-.86.507-1.778.938-2.59.391-.737.977-1.365 1.289-2.139.186-.461.266-.957.386-1.44.12-.484.289-.97.616-1.346.394-.452.987-.697 1.583-.766s1.199.024 1.784.157q.699.16 1.375.398c.384.137.765.296 1.097.533.453.322.797.775 1.072 1.258.274.483.485.999.716 1.503"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#020204",
    d: "M13.38 24.547q.718.04 1.43.146.626.095 1.241.245c.642.155 1.282.354 1.942.373.174.005.349-.003.52-.041a1.15 1.15 0 0 0 .47-.215c.202-.162.33-.405.379-.66s.018-.52-.057-.769c-.15-.496-.47-.92-.734-1.366-.152-.255-.287-.52-.452-.767-.164-.247-.361-.479-.61-.64-.346-.223-.774-.295-1.183-.255-.409.041-.8.189-1.166.378-.511.265-.992.628-1.271 1.132-.097.175-.168.364-.25.547a1.7 1.7 0 0 1-.319.506c-.155.16-.357.268-.519.423a.8.8 0 0 0-.191.272.47.47 0 0 0-.014.327.44.44 0 0 0 .131.186.6.6 0 0 0 .2.111c.145.05.3.058.453.067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#020204",
    d: "M11.957 24.516c-.4.01-.794.08-1.184.162a22 22 0 0 0-1.114.26c-.623.163-1.246.359-1.89.372-.17.004-.34-.005-.505-.043a1.14 1.14 0 0 1-.457-.212 1.1 1.1 0 0 1-.379-.66 1.65 1.65 0 0 1 .055-.766c.148-.496.465-.921.724-1.369.147-.255.277-.52.437-.767s.351-.479.597-.64c.335-.22.752-.295 1.151-.256.399.04.781.186 1.133.378.497.272.95.645 1.237 1.132.202.342.318.733.553 1.053.127.172.288.32.392.507a.75.75 0 0 1 .1.302.48.48 0 0 1-.073.305.5.5 0 0 1-.156.141.7.7 0 0 1-.198.073c-.14.028-.281.024-.423.027zM9.727 7.903c-.056-.674-.043-1.352-.068-2.029-.024-.65-.084-1.3-.062-1.95.023-.662.133-1.332.428-1.927A3.25 3.25 0 0 1 11.38.586C11.93.29 12.561.163 13.186.17c.846.01 1.694.265 2.379.761.43.311.79.712 1.075 1.159.243.381.432.798.55 1.236.244.896.186 1.84.233 2.767.045.878.186 1.754.138 2.633-.01.191-.031.385-.116.556a.95.95 0 0 1-.385.394 1.5 1.5 0 0 1-.528.173c-.367.057-.744.02-1.114.054-.538.05-1.051.249-1.585.332-.635.098-1.284.028-1.928.003-.257-.01-.516-.014-.771-.046a2.1 2.1 0 0 1-.739-.215 1.3 1.3 0 0 1-.373-.292 1 1 0 0 1-.225-.416c-.06-.23-.028-.474-.027-.712 0-.218-.025-.436-.044-.653z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFB",
    d: "M10.74 7.644c-.091.114-.15.25-.187.392a2 2 0 0 0-.054.434c-.011.292.006.59-.07.871-.084.301-.268.562-.45.816-.313.44-.63.892-.785 1.41a2.5 2.5 0 0 0-.092.972 10.3 10.3 0 0 0-.907 1.634 9 9 0 0 0-.735 2.728c-.113 1.152.034 2.338.49 3.403.328.77.819 1.474 1.451 2.023.322.279.68.517 1.062.704 1.324.651 2.96.652 4.262-.041.68-.363 1.255-.893 1.809-1.43.333-.323.665-.653.92-1.042.49-.748.66-1.657.766-2.544.185-1.552.191-3.192-.49-4.599a5 5 0 0 0-.92-1.317 7.2 7.2 0 0 0-.583-1.962c-.206-.449-.458-.876-.65-1.33-.078-.188-.148-.38-.234-.562a1.7 1.7 0 0 0-.342-.5 1.4 1.4 0 0 0-.534-.31 2.3 2.3 0 0 0-.611-.105c-.415-.02-.83.034-1.245.017-.33-.013-.66-.07-.99-.051-.165.01-.33.039-.483.101a1 1 0 0 0-.397.287z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.26,
    d: "M10.536 9.191c.149.43.447.797.8 1.083.117.096.242.184.38.246s.29.097.44.084a1 1 0 0 0 .417-.143c.13-.073.249-.16.374-.24.214-.136.444-.245.666-.367.268-.147.528-.314.754-.519.104-.094.2-.197.314-.278a.62.62 0 0 1 .39-.13c.106.006.204.051.306.073a.4.4 0 0 0 .157.009.24.24 0 0 0 .139-.068.24.24 0 0 0 .06-.178.44.44 0 0 0-.054-.183c-.06-.114-.151-.212-.191-.334-.037-.109-.03-.226-.026-.34a.7.7 0 0 0-.052-.337.44.44 0 0 0-.185-.18.7.7 0 0 0-.25-.07c-.174-.015-.348.018-.522.028-.231.013-.463-.016-.694-.002-.288.018-.57.101-.86.102-.329 0-.658-.108-.984-.056-.14.022-.272.073-.406.118a1.3 1.3 0 0 1-.415.082c-.16-.003-.315-.058-.476-.07a.6.6 0 0 0-.237.029.33.33 0 0 0-.18.151.3.3 0 0 0-.033.133.5.5 0 0 0 .015.137c.022.089.063.172.096.258.121.31.147.648.255.962z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__c)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.123 7.967c.288.178.546.396.763.645.202.231.373.493.636.665.185.12.408.189.634.21.266.024.535-.016.79-.085a3 3 0 0 0 .678-.274c.4-.227.735-.56 1.175-.71.096-.033.197-.056.29-.096s.18-.1.224-.186c.044-.082.041-.177.055-.267.015-.096.048-.189.066-.285a.45.45 0 0 0-.024-.286.4.4 0 0 0-.183-.167.7.7 0 0 0-.252-.057c-.175-.008-.348.033-.522.048-.23.02-.462-.008-.694-.002-.288.008-.572.068-.86.08-.327.015-.655-.033-.983-.043a2.2 2.2 0 0 0-.425.02c-.14.022-.278.066-.396.138-.115.07-.209.166-.314.248a1 1 0 0 1-.17.108.5.5 0 0 1-.198.051c-.035.002-.071-.001-.106.004a.2.2 0 0 0-.083.029.2.2 0 0 0-.064.056.193.193 0 0 0-.038.156z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__d)",
    d: "M10.873 4.036a.68.68 0 0 0-.417.186.94.94 0 0 0-.243.392c-.098.294-.076.614-.054.922.02.28.041.567.146.827.053.13.127.253.225.354a.76.76 0 0 0 .358.212.7.7 0 0 0 .39-.014.85.85 0 0 0 .335-.204c.138-.134.23-.31.283-.495s.068-.379.066-.57a2.4 2.4 0 0 0-.11-.711 1.6 1.6 0 0 0-.364-.617 1 1 0 0 0-.278-.209.7.7 0 0 0-.338-.074z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__e)",
    d: "M13.615 4.036a1.4 1.4 0 0 0-.543.674c-.125.349-.078.738.043 1.088.124.359.33.7.642.915.156.108.337.181.525.204a.96.96 0 0 0 .552-.096c.205-.107.36-.293.458-.503a1.8 1.8 0 0 0 .151-.672 2.3 2.3 0 0 0-.109-.87 1.47 1.47 0 0 0-.563-.754 1.1 1.1 0 0 0-.445-.169.95.95 0 0 0-.71.183"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__f)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m10.82 6.542-.446.407a.7.7 0 0 0-.193.27c-.031.094-.025.196-.04.294-.006.034-.014.067-.014.101q0 .026.007.05a.1.1 0 0 0 .025.045q.03.03.074.037c.028.006.056.006.084.01a.8.8 0 0 1 .349.147l.309.225c.237.15.521.218.803.229.281.01.562-.033.838-.088a4 4 0 0 0 .646-.178c.319-.125.606-.319.88-.524a4 4 0 0 0 .36-.297q.056-.057.116-.108a.4.4 0 0 1 .136-.08.5.5 0 0 1 .24-.004c.06.01.119.024.18.021a.3.3 0 0 0 .088-.018.2.2 0 0 0 .074-.052.18.18 0 0 0 .038-.11q-.001-.062-.032-.114a.4.4 0 0 0-.183-.148c-.1-.044-.208-.066-.314-.092a4.5 4.5 0 0 1-.943-.344c-.15-.074-.295-.156-.441-.235a2.6 2.6 0 0 0-.47-.208c-.366-.111-.767-.075-1.129.05-.402.14-.766.39-1.041.713"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__g)",
    d: "M11.6 6.081c.155-.173.26-.384.408-.562a1 1 0 0 1 .26-.228c.1-.057.216-.09.331-.08a.6.6 0 0 1 .343.163c.094.088.163.2.219.316.053.11.096.23.172.326.082.103.197.173.3.254q.08.06.143.136a.366.366 0 0 1 .07.373.44.44 0 0 1-.11.166.65.65 0 0 1-.36.161c-.264.037-.531-.041-.798-.034-.27.007-.535.103-.805.093a.7.7 0 0 1-.384-.115.5.5 0 0 1-.139-.146.4.4 0 0 1-.02-.38.7.7 0 0 1 .103-.163c.082-.1.182-.183.268-.28"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M14.616 1.293c-.223.158-.126.354-.03.552.096.197-.211.766-.214.79s.604-.288.77-.491c.195-.24.689.324.662.238 0-.153-.965-1.246-1.188-1.089"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#020204",
    d: "M14.174 4.767a.55.55 0 0 0-.257.087.7.7 0 0 0-.195.19 1 1 0 0 0-.156.516c-.006.137.01.276.055.405.045.13.122.249.227.336a.646.646 0 0 0 .782.036.7.7 0 0 0 .219-.25.9.9 0 0 0 .098-.318 1 1 0 0 0-.093-.575.8.8 0 0 0-.43-.388.6.6 0 0 0-.25-.039"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141413",
    d: "M14.39 5.363c-.075.03-.194.011-.227.085-.02.044.008.116.052.134.09.037.23-.03.266-.12.015-.039-.008-.1-.047-.117-.015-.006-.029.012-.043.018"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__k)",
    d: "M14.736 5.559c.1-.1-.072-.369-.207-.479-.098-.08-.382-.162-.37-.076s.14.197.226.282c.106.104.303.321.35.273"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__l",
    width: 4,
    height: 4,
    x: 12,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.616 4.036c-.222.185-.454.4-.544.674-.114.345-.142.776.043 1.088.341.573 1.078 1.206 1.719 1.023.424-.121.532-.74.61-1.175.05-.288.051-.626-.11-.87-.314-.478-.907-.861-1.48-.87-.09-.002-.169.072-.238.13"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#linux-color-icon_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__m)",
    d: "M12.702 4.917c.208-.173.448-.303.707-.383a1.95 1.95 0 0 1 1.6.198c.16.103.305.23.455.349s.31.23.49.293a.7.7 0 0 0 .305.043.56.56 0 0 0 .26-.097.7.7 0 0 0 .19-.203.9.9 0 0 0 .11-.54c-.032-.372-.242-.701-.418-1.03-.055-.104-.108-.209-.174-.305-.204-.296-.529-.49-.87-.605s-.7-.155-1.056-.2c-.159-.02-.32-.041-.479-.022-.182.022-.354.096-.533.141-.084.022-.17.037-.255.062a.7.7 0 0 0-.234.112c-.1.08-.163.2-.19.324-.027.125-.02.255 0 .38.04.253.133.5.124.754-.006.175-.06.347-.054.522q.004.079.022.153"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__o)",
    d: "M14.456 3.32a1 1 0 0 0-.109.17c.187.04.366.118.525.224.309.204.543.504.707.837a1 1 0 0 0 .103-.138c-.165-.348-.404-.661-.723-.873a1.6 1.6 0 0 0-.503-.22"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__q)",
    d: "M10.855 3.49q-.032-.001-.063.002l-.04.002c.122.011.245.044.356.094.151.068.285.165.402.275.218.204.38.456.49.723a1.8 1.8 0 0 0-.18-.58 2 2 0 0 0-.136-.143 1.5 1.5 0 0 0-.402-.275 1.1 1.1 0 0 0-.427-.099"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#020204",
    d: "M10.499 5.32c-.033.195-.034.4.033.587a1 1 0 0 0 .207.33c.058.063.124.12.201.157a.38.38 0 0 0 .25.032.37.37 0 0 0 .193-.13.6.6 0 0 0 .106-.21c.07-.224.059-.467-.01-.69a.9.9 0 0 0-.264-.43.5.5 0 0 0-.213-.111.37.37 0 0 0-.239.019.4.4 0 0 0-.187.188.9.9 0 0 0-.077.257"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__s)",
    d: "M10.912 5.178c.021.055.092.075.13.12.038.043.078.088.098.141.04.103-.039.254.044.327.026.022.078.023.103 0 .1-.091.078-.274.039-.403a.49.49 0 0 0-.234-.283c-.05-.026-.126-.047-.169-.01-.028.023-.024.074-.01.108"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__t)",
    d: "M10.135 7.75q.008.038.028.073.037.057.094.096.055.039.114.073c.203.128.368.307.515.497.198.254.372.536.636.721.186.13.408.205.634.228.266.026.535-.016.79-.092.238-.07.468-.168.678-.297.4-.247.735-.609 1.175-.771.096-.036.197-.061.29-.105a.46.46 0 0 0 .224-.201c.043-.09.04-.192.055-.29.015-.104.048-.205.066-.31a.52.52 0 0 0-.024-.31.4.4 0 0 0-.183-.181.6.6 0 0 0-.252-.063c-.175-.008-.348.037-.522.052-.23.022-.462-.008-.694-.001-.288.008-.572.073-.86.087-.327.016-.655-.035-.983-.048a2 2 0 0 0-.426.02 1 1 0 0 0-.395.152c-.114.08-.205.187-.31.278a.8.8 0 0 1-.171.117.44.44 0 0 1-.2.047c-.035 0-.073-.006-.107.004a.14.14 0 0 0-.056.036.3.3 0 0 0-.041.052 1 1 0 0 0-.076.136"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9B30D",
    d: "M11.423 8.103a.583.583 0 0 0 .378.683c.172.058.366.03.527-.054a.6.6 0 0 0 .233-.208.4.4 0 0 0 .052-.147.3.3 0 0 0-.016-.156.34.34 0 0 0-.1-.139.5.5 0 0 0-.15-.082 1 1 0 0 0-.343-.031q-.262.012-.52.065"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#604405",
    d: "m10.858 7.023-.34.223a.4.4 0 0 0-.145.147.3.3 0 0 0-.026.146c0 .05.002.1-.004.148-.005.033-.014.066-.015.1q-.002.026.005.05a.1.1 0 0 0 .024.045.13.13 0 0 0 .056.032q.032.009.064.015a.63.63 0 0 1 .27.157l.23.215c.22.18.513.255.796.26.284.004.566-.056.844-.118l.646-.178c.322-.119.622-.299.88-.524.118-.103.229-.215.36-.298.117-.073.248-.121.367-.191l.03-.02a.1.1 0 0 0 .024-.03q.014-.028.003-.061a.2.2 0 0 0-.031-.056.4.4 0 0 0-.05-.05c-.124-.106-.292-.145-.455-.157-.162-.013-.327-.004-.487-.031-.151-.026-.295-.082-.441-.129a3.107 3.107 0 0 0-1.598-.086 3.3 3.3 0 0 0-1.005.39z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__w)",
    d: "M10.821 6.629q-.253.17-.447.408a1 1 0 0 0-.176.296c-.03.087-.04.178-.058.267-.006.034-.014.067-.014.101a.2.2 0 0 0 .007.05.1.1 0 0 0 .026.045q.032.028.074.037.042.006.085.01a.8.8 0 0 1 .348.148l.309.224c.238.15.522.217.803.228s.562-.032.838-.087c.22-.044.438-.096.646-.178.319-.125.606-.319.88-.524a4 4 0 0 0 .36-.297q.056-.057.116-.109a.4.4 0 0 1 .136-.079.5.5 0 0 1 .24-.004c.06.01.12.024.18.021a.3.3 0 0 0 .089-.018.2.2 0 0 0 .073-.052.18.18 0 0 0 .038-.11q-.001-.061-.032-.114a.4.4 0 0 0-.183-.148c-.1-.044-.208-.066-.314-.092a4.5 4.5 0 0 1-.943-.344c-.15-.074-.294-.156-.441-.235a2.6 2.6 0 0 0-.47-.208c-.366-.111-.767-.075-1.129.05-.402.14-.765.39-1.041.713"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6DA4A",
    d: "M13.397 6.71a.16.16 0 0 0-.078-.052.2.2 0 0 0-.095-.004.4.4 0 0 0-.17.08c-.15.103-.281.229-.396.368a1.4 1.4 0 0 0-.319.633.4.4 0 0 0-.007.12c.005.04.02.08.05.109.024.025.058.04.093.045q.053.007.104-.011a.5.5 0 0 0 .176-.117c.29-.26.552-.571.658-.946a.4.4 0 0 0 .019-.116.2.2 0 0 0-.035-.11"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__y)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__z)",
    d: "M12.702 6.172c.02.064.124.053.184.084.053.028.096.087.155.089.056.002.145-.02.152-.076.01-.074-.098-.121-.168-.149-.09-.034-.205-.052-.29-.005-.018.01-.04.035-.033.057"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__A)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__B)",
    d: "M11.708 6.134c-.078-.025-.206.111-.164.181.011.02.047.044.07.03.036-.019.065-.09.103-.116.026-.019.02-.085-.01-.095"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__D)",
    d: "M15.116 7.46c.137 0 .264-.137.283-.307s-.077-.308-.214-.308c-.138 0-.265.138-.284.308s.077.308.215.308"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__E",
    width: 2,
    height: 5,
    x: 10,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.873 4.036c-.33.417-.742 1.017-.713 1.501.028.484.335 1.213.729 1.393.392.18.5 0 .724-.218.225-.219.336-.64.35-1.066.012-.427-.265-1.037-.474-1.327-.21-.29-.286-.7-.617-.283"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#linux-color-icon_svg__E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__F)",
    d: "M10.538 4.66c.234-.14.519-.172.79-.146.27.025.533.105.795.176.193.053.387.101.568.186.18.086.348.21.447.384l.047.083a.3.3 0 0 0 .063.073q.04.03.089.03a.1.1 0 0 0 .045-.014.1.1 0 0 0 .033-.034.1.1 0 0 0 .01-.054.3.3 0 0 0-.01-.054c-.065-.24-.22-.443-.338-.661l-.2-.4c-.245-.45-.648-.802-1.106-1.031-.457-.23-.968-.34-1.479-.37-.592-.034-1.185.036-1.77.14-.252.044-.51.096-.733.222a1 1 0 0 0-.295.245c-.08.1-.137.22-.156.348a.75.75 0 0 0 .044.365c.042.116.11.222.187.318.157.193.357.343.542.508s.357.347.562.484c.104.068.216.125.335.158s.246.043.368.018a.86.86 0 0 0 .344-.166c.102-.078.19-.172.274-.27.167-.194.324-.407.544-.539"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#020204",
    d: "M18.78 13.008c.53.426.866 1.069.97 1.74.081.525.029 1.062-.09 1.579-.117.516-.3 1.016-.48 1.514-.073.199-.145.4-.174.609s-.01.43.09.616c.116.213.332.36.564.429.23.068.477.066.71.009.232-.058.448-.171.637-.318.48-.373.77-.953.882-1.55s.06-1.214-.043-1.813a12.2 12.2 0 0 0-.686-2.385c-.224-.567-.486-1.125-.852-1.612-.358-.477-.81-.878-1.161-1.36-.244-.336-.44-.71-.732-1.004a1.5 1.5 0 0 0-.51-.348.97.97 0 0 0-.61-.04.96.96 0 0 0-.591.529 1.4 1.4 0 0 0-.09.802c.057.348.216.67.395.974.203.343.438.673.743.927.32.266.705.442 1.029.702"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__G",
    width: 6,
    height: 11,
    x: 16,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.78 13.008c.534.428.867 1.072.97 1.74.162 1.048-.207 2.096-.57 3.093a3 3 0 0 0-.175.609c-.029.208-.01.43.091.617.116.21.331.358.564.428.23.068.478.066.71.008.233-.058.449-.171.637-.317.486-.374.776-.956.886-1.553s.057-1.212-.048-1.81a12.4 12.4 0 0 0-.686-2.385c-.223-.567-.485-1.124-.852-1.612-.359-.476-.812-.879-1.161-1.36-.242-.335-.434-.708-.726-1.002a1.5 1.5 0 0 0-.511-.348 1 1 0 0 0-.615-.042.9.9 0 0 0-.357.2 1 1 0 0 0-.239.33 1.4 1.4 0 0 0-.085.801c.058.347.216.67.395.974.202.342.436.672.743.927.32.266.706.442 1.029.702"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__H)",
    mask: "url(#linux-color-icon_svg__G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#838384",
    d: "m17.534 12.187.133.12c.325.265.498.564.828.824.539.426 1.086 1.162 1.192 1.833.082.524-.027.809-.16 1.426-.134.618-.511 1.493-.716 2.088-.081.238.165.14.133.39a1.5 1.5 0 0 0-.003.371l.006-.072c.04-.341.144-.67.258-.991.22-.62.47-1.227.644-1.863s.154-1.094.064-1.64a2.76 2.76 0 0 0-1.08-1.741c-.4-.296-.872-.486-1.298-.745"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__I)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__J)",
    d: "M9.278 11.802c.089.132-.055.59 2.006.297 0 0-.362.04-.719.122-.554.186-1.037.393-1.41.668-.37.272-.64.627-.978.931 0 0 .548-1.002.685-1.304s-.023-.287.085-.732c.109-.446.373-.871.373-.871s-.216.627-.042.889"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__K)",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__L)",
    d: "M15.905 11.682c-.42.293-.666.258-1.176.315s-1.888.037-1.888.037.2-.004.642.078c.442.083 1.345.162 1.853.355.508.194.693.249 1.002.444.44.278.762.713 1.182 1.018 0 0 .02-.404-.149-.706-.17-.302-.626-.778-.76-1.222-.133-.444-.198-1.317-.198-1.317s-.088.705-.508.998"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__M)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__N)",
    d: "m11.955 11.057-.06.378a1 1 0 0 1-.05.183.4.4 0 0 1-.102.156.6.6 0 0 1-.141.085 2.1 2.1 0 0 1-.619.176l.256.023q.08.008.16.026a.4.4 0 0 1 .146.066.4.4 0 0 1 .113.134.9.9 0 0 1 .085.34q.02.225.002.45.016-.15.063-.295c.057-.173.149-.335.272-.469q.073-.08.162-.143a.9.9 0 0 1 .63-.153.98.98 0 0 1-.627-.195.8.8 0 0 1-.224-.252.7.7 0 0 1-.066-.51"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__O)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.418 14.02a8 8 0 0 0-.22 1.242c-.055.593-.042 1.19-.074 1.785-.026.505-.086 1.014.002 1.512a2.6 2.6 0 0 0 .222.685q.026-.123.037-.25c.037-.403-.031-.808-.054-1.213-.04-.709.058-1.418.098-2.126q.045-.817-.011-1.635"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__P)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#838384",
    d: "M16.308 7.909c-.188.171.088.429.22.731.08.188.306.453.524.41.164-.031.266-.267.25-.433-.03-.322-.3-.397-.497-.507-.156-.087-.365-.321-.497-.201"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__Q)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__R)",
    d: "M22.345 21.944a1.4 1.4 0 0 1-.183.384c-.177.262-.434.46-.69.642-.439.31-.895.595-1.302.948a6.5 6.5 0 0 0-.753.78c-.197.239-.383.49-.608.701a2.1 2.1 0 0 1-.782.482c-.35.114-.72.109-1.057.022-.236-.06-.467-.165-.613-.356-.147-.191-.195-.448-.212-.7-.03-.447.023-.903.072-1.356.04-.377.077-.754.093-1.13.027-.683-.018-1.36-.11-2.025-.016-.111-.033-.223-.023-.338a.54.54 0 0 1 .128-.322.54.54 0 0 1 .282-.154c.103-.024.208-.027.312-.028.244-.007.49-.021.732 0 .152.014.302.041.453.056.254.024.517.012.771-.063.274-.08.535-.23.814-.272q.172-.024.34 0a.64.64 0 0 1 .312.117.6.6 0 0 1 .153.201q.082.174.11.371c.018.115.024.233.054.345.049.182.159.338.292.464.133.127.288.227.443.325a5 5 0 0 0 .475.277c.078.038.157.072.231.116a.6.6 0 0 1 .192.168.48.48 0 0 1 .074.346"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__S",
    width: 9,
    height: 9,
    x: 16,
    y: 18,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.082 22.27c.079.139-.137.295-.246.412-.238.26-.561.427-.86.611-.516.317-1.1.514-1.604.846-.338.222-.638.498-.945.76-.263.226-.477.512-.769.699-.291.186-.613.361-.956.404a2.44 2.44 0 0 1-1.245-.188c-.27-.116-.536-.294-.693-.542-.158-.25-.18-.57-.194-.864-.027-.527.119-1.05.19-1.573.059-.435.16-.865.196-1.303.064-.796-.068-1.602.028-2.395.03-.255-.016-.58.175-.752.177-.16.473-.097.712-.092.291.006.577.082.86.15.18.041.349.122.53.157.299.057.605.092.91.082.33-.01.647-.156.977-.153.135.001.272.024.4.07.128.045.26.104.358.2.075.071.124.17.164.266.058.145.077.303.101.457.021.137-.013.285.036.415.16.417.485.76.803 1.074.152.168.35.307.537.42.197.12.38.213.475.42.058.128-.047.326.06.42"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#linux-color-icon_svg__S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__T)",
    d: "M24.081 22.27q-.088.227-.245.412c-.228.271-.545.45-.86.611-.54.275-1.098.516-1.604.846-.34.221-.652.481-.945.76-.25.24-.488.496-.769.699a2.2 2.2 0 0 1-.956.404 2.3 2.3 0 0 1-1.245-.188c-.273-.119-.536-.29-.693-.542-.158-.254-.194-.565-.194-.864 0-.529.097-1.053.19-1.573.076-.433.15-.866.196-1.303a13.4 13.4 0 0 0 .028-2.395c-.009-.133-.02-.268 0-.4a.57.57 0 0 1 .175-.352.57.57 0 0 1 .343-.123c.123-.007.247.013.369.03.288.043.579.076.86.15.178.047.352.11.53.158.295.08.605.118.91.082.328-.038.647-.161.977-.153q.204.006.399.07a.85.85 0 0 1 .359.2c.073.074.125.169.163.267.058.145.089.3.102.456.012.139.01.278.036.415.043.224.16.428.307.603.146.175.322.324.496.47.174.147.349.293.537.421.088.06.178.117.262.183s.16.143.213.236a.6.6 0 0 1 .06.42"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__U",
    width: 9,
    height: 9,
    x: 16,
    y: 18,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.082 22.27c.079.139-.137.295-.246.412-.238.26-.561.427-.86.611-.516.317-1.1.514-1.604.846-.338.222-.638.498-.945.76-.263.226-.477.512-.769.699-.291.186-.613.361-.956.404a2.44 2.44 0 0 1-1.245-.188c-.27-.116-.536-.294-.693-.542-.158-.25-.18-.57-.194-.864-.027-.527.119-1.05.19-1.573.059-.435.16-.865.196-1.303.064-.796-.068-1.602.028-2.395.03-.255-.016-.58.175-.752.177-.16.473-.097.712-.092.291.006.577.082.86.15.18.041.349.122.53.157.299.057.605.092.91.082.33-.01.647-.156.977-.153.135.001.272.024.4.07.128.045.26.104.358.2.075.071.124.17.164.266.058.145.077.303.101.457.021.137-.013.285.036.415.16.417.485.76.803 1.074.152.168.35.307.537.42.197.12.38.213.475.42.058.128-.047.326.06.42"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__V)",
    mask: "url(#linux-color-icon_svg__U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CD8907",
    d: "M23.81 21.996q-.082.204-.224.37c-.209.245-.498.406-.786.55-.492.246-1.001.462-1.464.76-.31.199-.595.432-.863.684-.23.215-.446.445-.702.627-.26.185-.559.318-.874.364a2.13 2.13 0 0 1-1.136-.17c-.249-.106-.489-.258-.633-.487-.143-.227-.177-.507-.177-.776-.002-.476.088-.946.173-1.414.07-.39.137-.78.18-1.172.077-.714.073-1.436.025-2.153-.008-.12-.018-.241 0-.36a.52.52 0 0 1 .16-.316.52.52 0 0 1 .313-.112c.113-.006.225.013.337.029.263.039.528.068.786.134.162.042.32.099.482.142.27.072.554.106.832.074.3-.034.59-.145.892-.138q.187.006.365.063c.12.037.24.09.328.18a.8.8 0 0 1 .149.24c.054.13.09.27.093.41.003.148-.03.296-.01.442.017.119.067.23.131.332.064.1.142.192.22.283.15.177.299.357.486.492.214.155.467.245.688.39.065.042.129.09.175.154a.41.41 0 0 1 .054.378"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__W",
    width: 9,
    height: 9,
    x: 16,
    y: 18,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.082 22.27c.078.139-.137.295-.246.412-.238.26-.561.427-.861.611-.515.317-1.098.515-1.603.846-.338.222-.638.498-.945.76-.263.226-.477.512-.77.699-.29.186-.612.361-.956.404a2.43 2.43 0 0 1-1.243-.188c-.27-.116-.537-.294-.693-.542-.158-.25-.18-.57-.194-.864-.027-.527.118-1.05.19-1.573.058-.435.16-.865.196-1.303.064-.796-.068-1.602.028-2.395.03-.255-.016-.58.175-.752.177-.16.472-.096.712-.092.29.006.577.083.86.15.18.041.348.122.529.157.298.058.606.093.91.083.33-.011.648-.157.978-.154.135.001.271.025.399.07a1 1 0 0 1 .359.2c.075.072.124.17.163.268.059.144.078.302.102.456.02.137-.014.285.036.415.159.417.485.76.802 1.074.152.168.351.308.537.42.198.12.38.213.476.42.057.128-.048.326.06.42z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__X)",
    mask: "url(#linux-color-icon_svg__W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C021",
    d: "M23.78 21.844q-.091.204-.23.374c-.214.26-.503.44-.808.555-.502.19-1.05.215-1.541.43-.3.132-.57.33-.844.517a4.2 4.2 0 0 1-.69.403c-.274.12-.565.187-.858.234-.186.03-.374.052-.562.041a1.2 1.2 0 0 1-.542-.15.76.76 0 0 1-.306-.313c-.075-.15-.087-.327-.086-.498.005-.456.102-.906.1-1.361-.003-.397-.082-.788-.104-1.184-.044-.76.12-1.535-.024-2.281-.023-.12-.054-.24-.052-.361q0-.092.03-.18a.33.33 0 0 1 .103-.143.3.3 0 0 1 .131-.056.4.4 0 0 1 .143 0c.094.015.184.052.276.08.263.078.54.076.807.135.168.038.33.098.496.143.279.076.569.11.855.076.307-.036.607-.148.916-.14.127.003.253.027.375.063a.8.8 0 0 1 .336.182.8.8 0 0 1 .154.242c.056.13.096.271.095.415 0 .075-.012.149-.019.223a.7.7 0 0 0 .01.223.6.6 0 0 0 .097.197c.043.06.091.114.135.172.124.162.212.352.308.535s.204.364.356.495c.207.18.476.251.706.393.068.041.133.09.18.157a.42.42 0 0 1 .056.38z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__Y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__Z)",
    d: "M17.233 18.682c.285-.077.527.14.734.302.134.114.327.086.49.091.272-.01.543.046.814.012.535-.046 1.06-.177 1.596-.2.257-.017.545-.031.767.118.09.063.222.326.31.227-.036-.276-.241-.544-.517-.618-.215-.034-.435.025-.651.006-.646-.015-1.288-.135-1.935-.1-.45.003-.9-.018-1.35-.035-.177-.037-.24.12-.336.18"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__aa)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M18.51 13.423c.104-.016.742.526.655.729s-.251.08-.368.081c-.118.002-.438.147-.492.055s.142-.306.244-.485c.083-.145-.142-.363-.038-.379"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__ab)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M9.51 10.01c-.01-.125-.189-.144-.269-.082-.067.053-.13.233-.072.303.094.114.355-.05.34-.221"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__ac)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__ad)",
    d: "M21.077 19.116a.46.46 0 0 0-.238-.209.8.8 0 0 0-.316-.054c-.215.002-.43.058-.644.04-.181-.016-.353-.084-.53-.127a1.14 1.14 0 0 0-.558-.013.82.82 0 0 0-.472.352c-.094.15-.14.327-.153.503-.014.177.001.354.019.53.013.128.027.255.058.38.03.124.079.245.154.35.108.149.268.255.44.319.287.104.6.099.883-.015.492-.214.91-.598 1.163-1.07q.138-.256.208-.537a1 1 0 0 0 .033-.227.5.5 0 0 0-.048-.222"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__ae)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__af)",
    d: "M21.077 19.016a.45.45 0 0 0-.238-.151c-.1-.03-.208-.04-.316-.04-.215.002-.43.042-.644.029-.181-.011-.353-.06-.53-.092a1.6 1.6 0 0 0-.558-.009.85.85 0 0 0-.472.255.65.65 0 0 0-.153.363 1.6 1.6 0 0 0 .019.384c.013.092.027.184.058.274.03.09.079.177.154.252a1 1 0 0 0 .44.232c.287.075.6.071.883-.012.492-.154.91-.431 1.163-.773q.138-.185.208-.388a.5.5 0 0 0 .033-.164.27.27 0 0 0-.048-.16"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#020204",
    d: "M21.486 18.219a.64.64 0 0 0-.173-.25 1 1 0 0 0-.26-.161c-.188-.08-.393-.11-.594-.148l-.568-.11c-.198-.034-.402-.056-.598-.012a1 1 0 0 0-.459.246c-.13.118-.23.266-.303.426a1.84 1.84 0 0 0-.144.906c.018.229.076.465.227.638.122.14.295.228.473.28a1.6 1.6 0 0 0 .945-.013c.506-.17.943-.5 1.247-.938.1-.144.184-.3.223-.47a.7.7 0 0 0-.016-.393z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__ag",
    width: 4,
    height: 4,
    x: 18,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.486 18.219a.64.64 0 0 0-.173-.25 1 1 0 0 0-.26-.161c-.188-.08-.393-.11-.594-.148l-.568-.11c-.198-.034-.402-.056-.598-.012a1 1 0 0 0-.459.246c-.13.118-.23.266-.303.426a1.84 1.84 0 0 0-.144.906c.018.229.076.465.227.638.122.14.295.228.473.28a1.6 1.6 0 0 0 .945-.013c.506-.17.943-.5 1.247-.938.1-.144.184-.3.223-.47a.7.7 0 0 0-.016-.393"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__ah)",
    mask: "url(#linux-color-icon_svg__ag)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__ai)",
    d: "M19.4 17.447a1.086 1.086 0 0 0-.876.525c-.11.188-.16.405-.144.622a1 1 0 0 1 .12-.432.89.89 0 0 1 .604-.44c.157-.03.316-.012.473.008.15.018.303.038.452.07.23.05.457.127.65.261a.6.6 0 0 1 .122.11c.035.041.063.09.074.143a.35.35 0 0 1-.047.232.9.9 0 0 1-.15.187q-.07.069-.143.133c.222-.043.448-.104.633-.233a.6.6 0 0 0 .196-.204.4.4 0 0 0 .043-.278.4.4 0 0 0-.092-.168.8.8 0 0 0-.147-.125 1.74 1.74 0 0 0-.788-.303 10 10 0 0 0-.547-.084 2.4 2.4 0 0 0-.432-.024"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__aj",
    width: 4,
    height: 4,
    x: 18,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.486 18.219a.64.64 0 0 0-.173-.25 1 1 0 0 0-.26-.161c-.188-.08-.393-.11-.594-.148l-.568-.11c-.198-.034-.402-.056-.598-.012a1 1 0 0 0-.459.246c-.13.118-.23.266-.303.426a1.84 1.84 0 0 0-.144.906c.018.229.076.465.227.638.122.14.295.228.473.28a1.6 1.6 0 0 0 .945-.013c.506-.17.943-.5 1.247-.938.1-.144.184-.3.223-.47a.7.7 0 0 0-.016-.393"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__ak)",
    mask: "url(#linux-color-icon_svg__aj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__al)",
    d: "M19.4 17.447a1.086 1.086 0 0 0-.876.525c-.11.188-.16.405-.144.622a1 1 0 0 1 .12-.432.89.89 0 0 1 .604-.44c.157-.03.316-.012.473.008.15.018.303.038.452.07.23.05.457.127.65.261a.6.6 0 0 1 .122.11c.035.041.063.09.074.143a.35.35 0 0 1-.047.232.9.9 0 0 1-.15.187q-.07.069-.143.133c.222-.043.448-.104.633-.233a.6.6 0 0 0 .196-.204.4.4 0 0 0 .043-.278.4.4 0 0 0-.092-.168.8.8 0 0 0-.147-.125 1.74 1.74 0 0 0-.788-.303 10 10 0 0 0-.547-.084 2.4 2.4 0 0 0-.432-.024"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#020204",
    d: "M9.503 9.437 8.03 11.281c-.307.381-.622.765-.822 1.212-.172.384-.253.802-.371 1.206a9 9 0 0 1-.52 1.335c-.188.399-.396.788-.604 1.178-.151.283-.305.572-.357.889-.042.25-.018.509.046.754.064.246.166.48.282.706a6.94 6.94 0 0 0 2.11 2.43c.398.288.824.538 1.27.742.243.11.498.21.764.214a.9.9 0 0 0 .39-.073.7.7 0 0 0 .303-.252.72.72 0 0 0 .101-.47 1.1 1.1 0 0 0-.166-.458c-.21-.341-.537-.588-.853-.833a29 29 0 0 1-1.974-1.675c-.178-.166-.357-.337-.481-.546a2 2 0 0 1-.232-.67 3.7 3.7 0 0 1 .127-1.926c.085-.24.198-.47.307-.7.188-.4.366-.806.613-1.172.308-.455.72-.84.97-1.33.212-.412.298-.876.38-1.333z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__am",
    width: 6,
    height: 13,
    x: 5,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.465 9.454s-.444.552-.687.891c-.243.34-.5.58-.748.936s-.64.82-.822 1.212-.202.787-.371 1.206c-.17.419-.322.926-.52 1.334-.197.409-.467.843-.604 1.178-.136.336-.331.498-.357.89-.026.391-.05.724.328 1.46.378.735 1.5 1.915 2.11 2.43s.817.629 1.27.742 1.206.26 1.457-.11c.25-.372.197-.52-.066-.929s-.42-.461-.852-.833c-.433-.372-1.622-1.294-1.974-1.675-.352-.38-.619-.296-.482-.546.138-.25-.192-.35-.23-.67-.067-.543.081-1.627.126-1.926s.107-.255.306-.7c.2-.445.36-.75.614-1.172.255-.421.75-.881.97-1.33.22-.448.305-.933.38-1.333s.152-1.055.152-1.055"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__an)",
    mask: "url(#linux-color-icon_svg__am)",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M8.096 12.905q-.305.28-.518.637c-.232.388-.37.824-.538 1.244-.126.312-.272.626-.29.962-.008.172.017.345.023.518s-.01.352-.096.503a.6.6 0 0 1-.325.274c.186.062.348.18.465.336.097.13.159.283.243.422.068.113.153.218.256.3a.73.73 0 0 0 .358.158.63.63 0 0 0 .502-.16 11.8 11.8 0 0 1 .448-4.683c.03-.095.06-.191.067-.29a.42.42 0 0 0-.071-.284.31.31 0 0 0-.427-.06.3.3 0 0 0-.098.123"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "linux-color-icon_svg__ao",
    width: 9,
    height: 9,
    x: 2,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.942 17.844a.8.8 0 0 1 .444-.04c.148.026.288.09.412.175.25.17.435.416.612.66.406.56.798 1.131 1.152 1.726.288.482.552.98.885 1.432.217.295.462.569.68.863s.411.614.508.968c.126.459.077.965-.141 1.388-.154.298-.39.553-.677.726a1.74 1.74 0 0 1-.959.25c-.532-.02-1.018-.286-1.512-.483-1.008-.402-2.103-.528-3.142-.84-.32-.097-.633-.21-.955-.299-.142-.039-.288-.073-.423-.135a.73.73 0 0 1-.336-.28.64.64 0 0 1-.08-.33c0-.114.028-.227.067-.334.078-.216.204-.41.289-.623.138-.347.163-.73.145-1.104-.02-.373-.08-.743-.105-1.116a2 2 0 0 1 .016-.5.82.82 0 0 1 .222-.44.83.83 0 0 1 .41-.201c.15-.032.305-.033.459-.03s.308.012.462 0a1.1 1.1 0 0 0 .44-.124c.128-.072.232-.18.318-.299.086-.118.156-.247.227-.375s.145-.255.239-.368a.9.9 0 0 1 .343-.267"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#linux-color-icon_svg__ao)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__ap)",
    d: "M5.942 17.844a.8.8 0 0 1 .444-.04c.148.026.288.09.412.175.25.17.435.416.612.66.406.56.798 1.131 1.152 1.726.288.482.552.98.885 1.432.217.295.462.569.68.863s.411.614.508.968c.126.459.077.965-.141 1.388-.154.298-.39.553-.677.726a1.74 1.74 0 0 1-.959.25c-.532-.02-1.018-.286-1.512-.483-1.008-.402-2.103-.528-3.142-.84-.32-.097-.633-.21-.955-.299-.142-.039-.288-.073-.423-.135a.73.73 0 0 1-.336-.28.64.64 0 0 1-.08-.33c0-.114.028-.227.067-.334.078-.216.204-.41.289-.623.138-.347.163-.73.145-1.104-.02-.373-.08-.743-.105-1.116a2 2 0 0 1 .016-.5.82.82 0 0 1 .222-.44.83.83 0 0 1 .41-.201c.15-.032.305-.033.459-.03s.308.012.462 0a1.1 1.1 0 0 0 .44-.124c.128-.072.232-.18.318-.299.086-.118.156-.247.227-.375s.145-.255.239-.368a.9.9 0 0 1 .343-.267"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__aq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D99A03",
    d: "M6.161 18.084a.7.7 0 0 1 .403-.026c.133.03.256.096.364.178.216.166.366.401.51.633.345.56.683 1.125 1.002 1.703.242.434.472.878.769 1.277.197.265.422.508.623.77.201.26.38.546.47.864.114.41.068.861-.13 1.238-.144.272-.36.499-.626.654a1.6 1.6 0 0 1-.878.217c-.487-.023-.932-.266-1.39-.431-.88-.32-1.833-.362-2.735-.611-.323-.088-.638-.205-.963-.287-.144-.036-.29-.066-.427-.123a.7.7 0 0 1-.34-.276.6.6 0 0 1-.073-.318c.003-.11.031-.217.07-.321.078-.206.202-.392.28-.599.12-.31.136-.653.113-.985-.022-.333-.08-.662-.1-.995-.009-.15-.01-.3.02-.446a.77.77 0 0 1 .2-.392.78.78 0 0 1 .433-.2 2 2 0 0 1 .483 0c.161.014.323.032.484.023a.9.9 0 0 0 .459-.14.9.9 0 0 0 .282-.33c.07-.13.119-.267.172-.403s.11-.271.193-.391a.76.76 0 0 1 .332-.282"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__ar)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5BD0C",
    d: "M6.044 17.768a.63.63 0 0 1 .402-.046.86.86 0 0 1 .365.18c.212.17.346.416.472.656.287.552.555 1.115.9 1.635.25.376.537.728.79 1.103.342.508.62 1.068.736 1.667.077.403.075.837-.12 1.201a1.34 1.34 0 0 1-.58.558 1.5 1.5 0 0 1-.8.148c-.43-.038-.822-.25-1.228-.398-.72-.262-1.498-.325-2.24-.523-.312-.083-.618-.19-.935-.256-.14-.03-.283-.05-.416-.1a.6.6 0 0 1-.328-.258.5.5 0 0 1-.057-.287.9.9 0 0 1 .075-.286c.078-.182.192-.35.253-.538.088-.277.052-.577-.015-.86-.066-.283-.161-.56-.19-.85a1.2 1.2 0 0 1 .016-.386.7.7 0 0 1 .184-.337.77.77 0 0 1 .46-.19c.168-.017.338.005.506.029s.337.051.506.043a.84.84 0 0 0 .475-.156.8.8 0 0 0 .26-.413c.048-.159.063-.324.083-.487a1.8 1.8 0 0 1 .107-.482.7.7 0 0 1 .32-.367"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#linux-color-icon_svg__as)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linux-color-icon_svg__at)",
    d: "M7.58 19.145c.227.41.366.881.59 1.295.208.38.443.772.653 1.123.094.156.312.396.533.769.2.338.402.81.515.967-.065-.185-.198-.683-.358-1.037-.148-.332-.322-.52-.429-.7-.21-.35-.436-.665-.652-1-.298-.461-.526-.978-.851-1.417"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__b",
    width: 7.312,
    height: 5.036,
    x: 9.295,
    y: 6.443,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.436
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__c",
    width: 6.094,
    height: 3.187,
    x: 9.736,
    y: 6.689,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.192
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__f",
    width: 6.414,
    height: 3.813,
    x: 9.544,
    y: 5.128,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.292
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__h",
    width: 3.152,
    height: 3.077,
    x: 13.513,
    y: 0.419,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.429
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__i",
    width: 0.542,
    height: 0.462,
    x: 14.05,
    y: 5.237,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.053
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__j",
    width: 1.052,
    height: 1.043,
    x: 13.937,
    y: 4.745,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.111
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__n",
    width: 1.462,
    height: 1.359,
    x: 14.284,
    y: 3.256,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.032
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__p",
    width: 1.364,
    height: 1.213,
    x: 10.694,
    y: 3.431,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.029
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__r",
    width: 0.896,
    height: 1.173,
    x: 10.682,
    y: 4.83,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.11
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__u",
    width: 1.979,
    height: 1.621,
    x: 11.023,
    y: 7.581,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.193
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__v",
    width: 5.254,
    height: 2.644,
    x: 10.003,
    y: 6.241,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.162
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__x",
    width: 1.829,
    height: 2.088,
    x: 11.967,
    y: 6.287,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.182
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__y",
    width: 0.587,
    height: 0.353,
    x: 12.654,
    y: 6.039,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.024
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__A",
    width: 0.292,
    height: 0.312,
    x: 11.489,
    y: 6.084,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.024
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__C",
    width: 0.795,
    height: 0.908,
    x: 14.753,
    y: 6.699,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.073
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__H",
    width: 3.615,
    height: 8.221,
    x: 16.95,
    y: 11.602,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.292
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__I",
    width: 3.699,
    height: 3.499,
    x: 7.881,
    y: 10.617,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.148
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__K",
    width: 5.656,
    height: 4.22,
    x: 12.353,
    y: 10.196,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.244
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__M",
    width: 2.561,
    height: 2.691,
    x: 10.647,
    y: 10.72,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.168
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__O",
    width: 1.609,
    height: 6.464,
    x: 10.46,
    y: 13.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.31
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__P",
    width: 1.832,
    height: 1.952,
    x: 15.858,
    y: 7.489,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.193
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__Q",
    width: 8.133,
    height: 8.683,
    x: 15.177,
    y: 18.244,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.48
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__V",
    width: 10.978,
    height: 11.075,
    x: 14.903,
    y: 16.342,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 1.024
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__X",
    width: 9.795,
    height: 9.763,
    x: 15.619,
    y: 16.252,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.807
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__Y",
    width: 5.2,
    height: 1.185,
    x: 16.95,
    y: 18.274,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.103
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__aa",
    width: 2.841,
    height: 2.86,
    x: 17.314,
    y: 12.441,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.491
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__ab",
    width: 0.912,
    height: 0.923,
    x: 8.872,
    y: 9.62,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.137
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__ac",
    width: 5.4,
    height: 4.975,
    x: 16.942,
    y: 17.506,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.609
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__ae",
    width: 3.908,
    height: 2.779,
    x: 17.688,
    y: 18.26,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.236
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__ah",
    width: 3.918,
    height: 2.3,
    x: 17.938,
    y: 17.005,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__ak",
    width: 3.918,
    height: 2.3,
    x: 17.938,
    y: 17.005,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__an",
    width: 3.311,
    height: 6.512,
    x: 5.867,
    y: 12.236,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.243
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__aq",
    width: 10.986,
    height: 10.916,
    x: 1.058,
    y: 16.358,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.841
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__ar",
    width: 8.822,
    height: 9.238,
    x: 1.969,
    y: 16.673,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.517
  })), /*#__PURE__*/React.createElement("filter", {
    id: "linux-color-icon_svg__as",
    width: 2.607,
    height: 4.471,
    x: 7.422,
    y: 18.987,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8544_213656",
    stdDeviation: 0.079
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.64084 -.91082 2.22936 52.9692 336.176 490.319)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-1.81 16556.044 -18843.734)scale(38.7791 56.0393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D4D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(28.73974 -20.88716 13.85616 19.06542 643.756 -169.403)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(154.73134 -63.86414 22.18761 53.7566 1594.59 -257.413)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2940A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#D89C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#B67E07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946106"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.59228 0 0 .48747 50.99 28.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#735208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8C04"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.30382 0 0 .36017 24.03 40.718)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#735208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8C04"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__F",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-9.349 280.053 -2109.45)scale(44.1739 18.9477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797978"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-59.4498 0 0 -60.7934 -692.581 500.612)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(128.21 0 0 67.8466 1448.75 595.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(20.4748 0 0 23.4051 506.062 496.023)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__ad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(65.30518 17.49847 -15.72859 58.6999 1108.07 1443.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#A65A00",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__af",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(65.30518 12.65005 -8.49162 43.83753 1108.07 1048.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#A65A00",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "linux-color-icon_svg__ai",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(22.48949 9.78884 -2.11632 4.86218 412.92 258.632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__k",
    x1: 198.157,
    x2: 202.166,
    y1: 84.419,
    y2: 89.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494",
    stopOpacity: 0.392
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494",
    stopOpacity: 0.392
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__m",
    x1: 381.846,
    x2: 454.334,
    y1: 363.929,
    y2: 423.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__o",
    x1: 35.058,
    x2: 52.617,
    y1: 133.39,
    y2: 151.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#646464",
    stopOpacity: 0.583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#646464",
    stopOpacity: 0.257
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__q",
    x1: -21.422,
    x2: -6.771,
    y1: 120.522,
    y2: 136.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#646464",
    stopOpacity: 0.583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#646464",
    stopOpacity: 0.257
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__s",
    x1: 85.822,
    x2: 90.811,
    y1: 101.845,
    y2: 107.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757574",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#757574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#757574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757574",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__w",
    x1: 256.068,
    x2: 552.467,
    y1: 424.752,
    y2: 420.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD780A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D89E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#EDB80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#EBC80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#F5D838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#F6D811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CD31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__D",
    x1: 124.981,
    x2: 125.297,
    y1: 103.438,
    y2: 105.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5CE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D79B08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__R",
    x1: 191.939,
    x2: 219.063,
    y1: 2210.27,
    y2: 2396.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__T",
    x1: 3343.66,
    x2: 3721.98,
    y1: 2902.49,
    y2: 2307.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD780A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__Z",
    x1: 233.454,
    x2: 233.274,
    y1: 242.844,
    y2: 252.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CD0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CD0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__al",
    x1: 1108.07,
    x2: 1117.13,
    y1: 414.678,
    y2: 413.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__ap",
    x1: 1023.7,
    x2: 1413.22,
    y1: 2491.61,
    y2: 3152.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382605"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linux-color-icon_svg__at",
    x1: 399.326,
    x2: 474.607,
    y1: 1357.76,
    y2: 1435.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC40C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBC40C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "linux-color-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
};
export default SvgLinuxColorIcon;